import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthService} from '../services/auth/auth.service';
import {AuthGuardService, AuthGuardService as authGuard} from '../services/auth/auth-guard.service';

import {LoginComponent} from './login/login.component';
import {HomepageComponent} from './homepage/homepage.component';

import {EmployeeService} from '../services/api/EmployeeService';
import {UserService} from '../services/api/UserService';
import {ContractualDataComponent} from './contractual-data/contractual-data.component';
import {MonthlyActualComponent} from './monthly-actual/monthly-actual.component';
import {ServiceChangesComponent} from './service-changes/service-changes.component';
import {MonthlyChargesComponent} from './monthly-charges/monthly-charges.component';
import {SettingsComponent} from './settings/settings.component';
import {MasterDataComponent} from './anagrafiche/master-data.component';
import {RegionAnagrafComponent} from './anagrafiche/region-anagraf/region-anagraf.component';
import {LocalCustomerAnagrafComponent} from './anagrafiche/local-customer-anagraf/local-customer-anagraf.component';
import {ResourcesUnitsAnagrafComponent} from './anagrafiche/resources-units-anagraf/resources-units-anagraf.component';
import {ContractTypeAnagrafComponent} from './anagrafiche/contract-type/contract-type-anagraf.component';
import {Sl1AnagrafComponent} from './anagrafiche/sl1-anagraf/sl1-anagraf.component';
import {Sl2AnagrafComponent} from './anagrafiche/sl2-anagraf/sl2-anagraf.component';
import {Sl3AnagrafComponent} from './anagrafiche/sl3-anagraf/sl3-anagraf.component';
import {Sl4AnagrafComponent} from './anagrafiche/sl4-anagraf/sl4-anagraf.component';
import {Sl5AnagrafComponent} from './anagrafiche/sl5-anagraf/sl5-anagraf.component';
import {UnitsAnagrafComponent} from './anagrafiche/units-anagraf/units-anagraf.component';
import {NewRegionAnagrafComponent} from './anagrafiche/region-anagraf/new-region-anagraf/new-region-anagraf.component';
import {NewContractTypeAnagrafComponent} from './anagrafiche/contract-type/new-contract-type-anagraf/new-contract-type-anagraf.component';
import {NewLocalCustomerAnagrafComponent} from './anagrafiche/local-customer-anagraf/new-local-customer-anagraf/new-local-customer-anagraf.component';
import {NewSl1AnagrafComponent} from './anagrafiche/sl1-anagraf/new-sl1-anagraf/new-sl1-anagraf.component';
import {NewResourcesUnitsAnagrafComponent} from './anagrafiche/resources-units-anagraf/new-resources-units-anagraf/new-resources-units-anagraf.component';
import {NewSl2AnagrafComponent} from './anagrafiche/sl2-anagraf/new-sl2-anagraf/new-sl2-anagraf.component';
import {NewSl3AnagrafComponent} from './anagrafiche/sl3-anagraf/new-sl3-anagraf/new-sl3-anagraf.component';
import {NewSl4AnagrafComponent} from './anagrafiche/sl4-anagraf/new-sl4-anagraf/new-sl4-anagraf.component';
import {NewSl5AnagrafComponent} from './anagrafiche/sl5-anagraf/new-sl5-anagraf/new-sl5-anagraf.component';
import {NewUnitsAnagrafComponent} from './anagrafiche/units-anagraf/new-units-anagraf/new-units-anagraf.component';
import {ProjectConstants} from './project-constants';
import {EditRegionAnagrafComponent} from './anagrafiche/region-anagraf/edit-region-anagraf/edit-region-anagraf.component';
import {EditLocalCustomerAnagrafComponent} from './anagrafiche/local-customer-anagraf/edit-local-customer-anagraf/edit-local-customer-anagraf.component';
import {EditSl1AnagrafComponent} from './anagrafiche/sl1-anagraf/edit-sl1-anagraf/edit-sl1-anagraf.component';
import {EditUnitsAnagrafComponent} from './anagrafiche/units-anagraf/edit-units-anagraf/edit-units-anagraf.component';
import {EditResourceAnagrafComponent} from './anagrafiche/resources-units-anagraf/edit-resource-anagraf/edit-resource-anagraf.component';
import {EditContractTypeAnagrafComponent} from './anagrafiche/contract-type/edit-contract-type-anagraf/edit-contract-type-anagraf.component';
import {EditSl2AnagrafComponent} from './anagrafiche/sl2-anagraf/edit-sl2-anagraf/edit-sl2-anagraf.component';
import {EditSl3AnagrafComponent} from './anagrafiche/sl3-anagraf/edit-sl3-anagraf/edit-sl3-anagraf.component';
import {EditSl4AnagrafComponent} from './anagrafiche/sl4-anagraf/edit-sl4-anagraf/edit-sl4-anagraf.component';
import {EditSl5AnagrafComponent} from './anagrafiche/sl5-anagraf/edit-sl5-anagraf/edit-sl5-anagraf.component';
import {CurrencyAnagrafComponent} from './anagrafiche/currency-anagraf/currency-anagraf.component';
import {NewCurrencyAnagrafComponent} from './anagrafiche/currency-anagraf/new-currency-anagraf/new-currency-anagraf.component';
import {EditCurrencyAnagrafComponent} from './anagrafiche/currency-anagraf/edit-currency-anagraf/edit-currency-anagraf.component';
import {NewLocalCustomerComponent} from './settings/local-customer/new-local-customer/new-local-customer.component';
import {NewArchitectureStructureComponent} from './settings/architecture-structure/new-architecture-structure/new-architecture-structure.component';
import {NewContractComponent} from './settings/contract/new-contract/new-contract.component';
import {NewCurrencyComponent} from './settings/currency/new-currency/new-currency.component';
import {EditLocalCustomerComponent} from './settings/local-customer/edit-local-customer/edit-local-customer.component';
import {LocalCustomerSettingsModel} from '../models/LocalCustomerSettingsModel';
import {EditContractComponent} from './settings/contract/edit-contract/edit-contract.component';
import {ContractSettingsModel} from '../models/ContractSettingsModel';
import {EditArchitectureStructureComponent} from './settings/architecture-structure/edit-architecture-structure/edit-architecture-structure.component';
import {ArchitectureStructureSettingModel} from '../models/ArchitectureStructureSettingModel';
import {EditCurrencySettingComponent} from './settings/currency/edit-currency-setting/edit-currency-setting.component';
import {CurrencySettingModel} from '../models/CurrencySettingModel';
import {NewDiscountComponent} from './contractual-data/discount/new-discount/new-discount.component';
import {EditDiscountComponent} from './contractual-data/discount/edit-discount/edit-discount.component';
import {NewContractualValuesComponent} from './contractual-data/contractual-values/new-contractual-values/new-contractual-values.component';
import {EditContractualValuesComponent} from './contractual-data/contractual-values/edit-contractual-values/edit-contractual-values.component';
import {ContractualDataModel} from '../models/ContractualDataModel';
import {NewMinimumCommComponent} from './contractual-data/minimum-comm/new-minimum-comm/new-minimum-comm.component';
import {EditMinimumCommComponent} from './contractual-data/minimum-comm/edit-minimum-comm/edit-minimum-comm.component';
import {MinimumCommModel} from '../models/MinimumCommModel';
import {NewServiceChangesComponent} from './service-changes/new-service-changes/new-service-changes.component';
import {EditServiceChangesComponent} from './service-changes/edit-service-changes/edit-service-changes.component';
import {ServiceChangesModel} from '../models/ServiceChangesModel';
import {ContractTypeModel} from '../models/ContractTypeModel';
import {CurrencyModel} from '../models/CurrencyModel';
import {DesignServicesModel} from '../models/DesignServicesModel';
import {L1Model} from '../models/L1Model';
import {L2Model} from '../models/L2Model';
import {L3Model} from '../models/L3Model';
import {LayerModel} from '../models/LayerModel';
import {LocalCustomerModel} from '../models/LocalCustomerModel';
import {RegionModel} from '../models/RegionModel';
import {ResourcesUnitModel} from '../models/ResourcesUnitModel';
import {UnitsModel} from '../models/UnitsModel';
import {NewContractualValuesMassiveComponent} from './contractual-data/contractual-values/new-contractual-values-massive/new-contractual-values-massive.component';
import {EditContractualValuesMassiveComponent} from './contractual-data/contractual-values/edit-contractual-values-massive/edit-contractual-values-massive.component';
import {EditDiscountMassiveComponent} from './contractual-data/discount/edit-discount-massive/edit-discount-massive.component';
import {NewDiscountMassiveComponent} from './contractual-data/discount/new-discount-massive/new-discount-massive.component';
import {UsersComponent} from './users/users.component';
import {NewUsersComponent} from './users/new-users/new-users.component';
import {EditUsersComponent} from './users/edit-users/edit-users.component';
import {UserModel} from '../models/UserModel';
import {ProviderAnagrafComponent} from './anagrafiche/provider-anagraf/provider-anagraf.component';
import {NewProviderAnagrafComponent} from './anagrafiche/provider-anagraf/new-provider-anagraf/new-provider-anagraf.component';
import {EditProviderAnagrafComponent} from './anagrafiche/provider-anagraf/edit-provider-anagraf/edit-provider-anagraf.component';
import {ProviderModel} from '../models/ProviderModel';
import {NewServiceChangesMassiveComponent} from './service-changes/new-service-changes-massive/new-service-changes-massive.component';
import {EditServiceChangesMassiveComponent} from './service-changes/edit-service-changes-massive/edit-service-changes-massive.component';
import {RoleGuard} from '../services/auth/role-guard.serivce';
import { ReportingComponent } from './reporting/reporting.component';
import {SizeAnagrafComponent} from './anagrafiche/size-anagraf/size-anagraf.component';
import {SiteAnagrafComponent} from './anagrafiche/site-anagraf/site-anagraf.component';
import {SharenameDeviceAnagrafComponent} from './anagrafiche/sharename-device-anagraf/sharename-device-anagraf.component';
import {EditSizeAnagrafComponent} from './anagrafiche/size-anagraf/edit-size-anagraf/edit-size-anagraf.component';
import {SizeModel} from '../models/SizeModel';
import {NewSizeAnagrafComponent} from './anagrafiche/size-anagraf/new-size-anagraf/new-size-anagraf.component';
import {NewSiteAnagrafComponent} from './anagrafiche/site-anagraf/new-site-anagraf/new-site-anagraf.component';
import {EditSiteAnagrafComponent} from './anagrafiche/site-anagraf/edit-site-anagraf/edit-site-anagraf.component';
import {NewSharenameDeviceAnagrafComponent} from './anagrafiche/sharename-device-anagraf/new-sharename-device-anagraf/new-sharename-device-anagraf.component';
import {EditSharenameDeviceAnagrafComponent} from './anagrafiche/sharename-device-anagraf/edit-sharename-device-anagraf/edit-sharename-device-anagraf.component';
import {ShareNameDeviceModel} from '../models/ShareNameDeviceModel';
import {TerminationFeeComponent} from './contractual-data/termination-fee/termination-fee.component';
import {OrganizationUnitAnagrafComponent} from "./anagrafiche/organization-unit-anagraf/organization-unit-anagraf.component";
import {NewOrganizationUnitAnagrafComponent} from "./anagrafiche/organization-unit-anagraf/new-organization-unit-anagraf/new-organization-unit-anagraf.component";
import {EditOrganizationUnitAnagrafComponent} from "./anagrafiche/organization-unit-anagraf/edit-organization-unit-anagraf/edit-organization-unit-anagraf.component";
import {OrganizationUnitModel} from "../models/OrganizationUnitModel";
import {EditReimbursmentComponent} from './contractual-data/reimbursment/edit-reimbursment/edit-reimbursment.component';
import {EditTerminationFeeComponent} from './contractual-data/termination-fee/edit-termination-fee/edit-termination-fee.component';
import {RoleAnagrafModel} from '../models/RoleAnagrafModel';
import {RateTypeAnagrafComponent} from './anagrafiche/rate-type-anagraf/rate-type-anagraf.component';
import {RoleAnagrafComponent} from './anagrafiche/role-anagraf/role-anagraf.component';
import {NewRoleAnagrafComponent} from './anagrafiche/role-anagraf/new-role-anagraf/new-role-anagraf.component';
import {NewRateTypeAnagrafComponent} from './anagrafiche/rate-type-anagraf/new-rate-type-anagraf/new-rate-type-anagraf.component';
import {EditRoleAnagrafComponent} from './anagrafiche/role-anagraf/edit-role-anagraf/edit-role-anagraf.component';
import {EditRateTypeAnagrafComponent} from './anagrafiche/rate-type-anagraf/edit-rate-type-anagraf/edit-rate-type-anagraf.component';
import {ServiceVariantAnagrafComponent} from "./anagrafiche/service-variant-anagraf/service-variant-anagraf.component";
import {NewServiceVariantAnagrafComponent} from "./anagrafiche/service-variant-anagraf/new-service-variant-anagraf/new-service-variant-anagraf.component";
import {EditServiceVariantAnagrafComponent} from "./anagrafiche/service-variant-anagraf/edit-service-variant-anagraf/edit-service-variant-anagraf.component";
import {ServiceVariantModel} from "../models/ServiceVariantModel";
import {EditRateCardComponent} from './contractual-data/rate-card/edit-rate-card/edit-rate-card.component';
import {NewRateCardComponent} from './contractual-data/rate-card/new-rate-card/new-rate-card.component';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {TabGroupComponent} from "./contractual-data/tab-group/tab-group.component";
import {MonthlyChargesTabComponent} from "./monthly-charges/monthly-charges-tab/monthly-charges-tab.component";
import {EditTransformationComponent} from "./contractual-data/transformation/edit-transformation/edit-transformation.component";
import {TransformationModel} from "../models/TransformationModel";

const PROJECT_CONSTANTS = new ProjectConstants();
// canActivate: [authGuard], --> ci servirà per riabilitare le session di login
const routes: Routes = [
  {path: '', redirectTo: 'login', pathMatch: 'full'},

  {path: 'homepage', component: HomepageComponent},

  {path: 'login', component: LoginComponent},

  {path: 'contractual-data', component: ContractualDataComponent},

  {path: 'monthly-actual', component: MonthlyActualComponent},

  {path: 'service-changes', component: ServiceChangesComponent},

  {path: 'monthly-charges', component: MonthlyChargesComponent},

  {path: 'reporting', component: ReportingComponent},

  {path: 'dashboard', component: DashboardComponent},

  {path: 'settings/:selectedIndex', component: SettingsComponent},

  {path: 'settings', component: SettingsComponent},

  {path: 'users', component: UsersComponent, canActivate: [RoleGuard]},

  {path: 'termination-fee', component: TerminationFeeComponent},

  {path: 'master-data',
    children: [
      {
        path: '',
        component: MasterDataComponent,
        children: [
          {path: 'region-anagraf', component: RegionAnagrafComponent},
          {path: 'local-customer-anagraf', component: LocalCustomerAnagrafComponent},
          {path: 'resource-units-anagraf', component: ResourcesUnitsAnagrafComponent},
          {path: 'contract-type-anagraf', component: ContractTypeAnagrafComponent},
          {path: 'sl1-anagraf', component: Sl1AnagrafComponent},
          {path: 'sl2-anagraf', component: Sl2AnagrafComponent},
          {path: 'sl3-anagraf', component: Sl3AnagrafComponent},
          {path: 'sl4-anagraf', component: Sl4AnagrafComponent},
          {path: 'sl5-anagraf', component: Sl5AnagrafComponent},
          {path: 'units-anagraf', component: UnitsAnagrafComponent},
          {path: 'currency-anagraf', component: CurrencyAnagrafComponent},
          {path: 'provider-anagraf', component: ProviderAnagrafComponent},
          {path: 'size-anagraf', component: SizeAnagrafComponent},
          {path: 'site-anagraf', component: SiteAnagrafComponent},
          {path: 'role-anagraf', component: RoleAnagrafComponent},
          {path: 'rate-type-anagraf', component: RateTypeAnagrafComponent},
          {path: 'sharename-device-anagraf', component: SharenameDeviceAnagrafComponent},
          {path: 'organization-unit-anagraf', component: OrganizationUnitAnagrafComponent},
          {path: 'service-variant-anagraf', component: ServiceVariantAnagrafComponent},
        ], canActivate: [RoleGuard]
      }
    ]
  },

  {path: 'reporting',
    children: [
      {
        path: '',
        component: ReportingComponent,
        children: [
          {path: 'contractual-data', component: ContractualDataComponent},
          {path: 'monthly-actual', component: MonthlyActualComponent},
          {path: 'monthly-charges', component: MonthlyChargesComponent}
        ], canActivate: [RoleGuard]
      }
    ]
  },

  {path: 'new-region-anagraf', component: NewRegionAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-local-customer-anagraf', component: NewLocalCustomerAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-local-customer', component: NewLocalCustomerComponent, canActivate: [RoleGuard]},

  {path: 'new-contract', component: NewContractComponent, canActivate: [RoleGuard]},

  {path: 'new-contract-type-anagraf', component: NewContractTypeAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-resources-units-anagraf', component: NewResourcesUnitsAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sl1-anagraf', component: NewSl1AnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sl2-anagraf', component: NewSl2AnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sl3-anagraf', component: NewSl3AnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sl4-anagraf', component: NewSl4AnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sl5-anagraf', component: NewSl5AnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-units-anagraf', component: NewUnitsAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-currency-anagraf', component: NewCurrencyAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-provider-anagraf', component: NewProviderAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-size-anagraf', component: NewSizeAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-site-anagraf', component: NewSiteAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-role-anagraf', component: NewRoleAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-rate-type-anagraf', component: NewRateTypeAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-sharename-device-anagraf', component: NewSharenameDeviceAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-organization-unit-anagraf', component: NewOrganizationUnitAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'new-currency', component: NewCurrencyComponent, canActivate: [RoleGuard]},

  {path: 'new-discount', component: NewDiscountComponent, canActivate: [RoleGuard]},

  {path: 'new-discount-massive', component: NewDiscountMassiveComponent, canActivate: [RoleGuard]},

  {path: 'new-contractual-values', component: NewContractualValuesComponent, canActivate: [RoleGuard]},

  {path: 'new-contractual-values-massive', component: NewContractualValuesMassiveComponent, canActivate: [RoleGuard]},

  {path: 'new-minimum-comm', component: NewMinimumCommComponent, canActivate: [RoleGuard]},

  {path: 'new-rate-card', component: NewRateCardComponent, canActivate: [RoleGuard]},

  {path: 'new-architecture-structure', component: NewArchitectureStructureComponent, canActivate: [RoleGuard]},

  {path: 'new-service-changes', component: NewServiceChangesComponent, canActivate: [RoleGuard]},

  {path: 'new-service-changes-massive', component: NewServiceChangesMassiveComponent, canActivate: [RoleGuard]},

  {path: 'new-service-variant-anagraf', component: NewServiceVariantAnagrafComponent, canActivate: [RoleGuard]},

  {path: 'edit-region-anagraf', component: EditRegionAnagrafComponent, data : {row : RegionModel}, canActivate: [RoleGuard]},

  {path: 'edit-local-customer-anagraf', component: EditLocalCustomerAnagrafComponent, data : {row : LocalCustomerModel}, canActivate: [RoleGuard]},

  {path: 'edit-units-anagraf', component: EditUnitsAnagrafComponent, data : {row : UnitsModel}, canActivate: [RoleGuard]},

  {path: 'edit-design-services-anagraf', component: EditSl1AnagrafComponent, data : {row : DesignServicesModel}, canActivate: [RoleGuard]},

  {path: 'edit-resource-unit-anagraf', component: EditResourceAnagrafComponent, data : {row : ResourcesUnitModel}, canActivate: [RoleGuard]},

  {path: 'edit-contract-type-anagraf', component: EditContractTypeAnagrafComponent, data : {row : ContractTypeModel}, canActivate: [RoleGuard]},

  {path: 'edit-sl1-anagraf', component: EditSl1AnagrafComponent, data : {row : DesignServicesModel}, canActivate: [RoleGuard]},

  {path: 'edit-sl2-anagraf', component: EditSl2AnagrafComponent, data : {row : LayerModel}, canActivate: [RoleGuard]},

  {path: 'edit-sl3-anagraf', component: EditSl3AnagrafComponent, data : {row : L1Model}, canActivate: [RoleGuard]},

  {path: 'edit-sl4-anagraf', component: EditSl4AnagrafComponent, data : {row : L2Model}, canActivate: [RoleGuard]},

  {path: 'edit-sl5-anagraf', component: EditSl5AnagrafComponent, data : {row : L3Model}, canActivate: [RoleGuard]},

  {path: 'edit-currency-anagraf', component: EditCurrencyAnagrafComponent, data : {row : CurrencyModel}, canActivate: [RoleGuard]},

  {path: 'edit-provider-anagraf', component: EditProviderAnagrafComponent, data : {row : ProviderModel}, canActivate: [RoleGuard]},

  {path: 'edit-size-anagraf', component: EditSizeAnagrafComponent, data : {row : SizeModel}, canActivate: [RoleGuard]},

  {path: 'edit-site-anagraf', component: EditSiteAnagrafComponent, data : {row : SizeModel}, canActivate: [RoleGuard]},

  {path: 'edit-role-anagraf', component: EditRoleAnagrafComponent, data : {row : SizeModel}, canActivate: [RoleGuard]},

  {path: 'edit-rate-type-anagraf', component: EditRateTypeAnagrafComponent, data : {row : SizeModel}, canActivate: [RoleGuard]},

  {path: 'edit-rate-type-anagraf', component: EditRateTypeAnagrafComponent, data : {row : SizeModel}, canActivate: [RoleGuard]},

  {path: 'edit-sharename-device-anagraf', component: EditSharenameDeviceAnagrafComponent, data: {row: ShareNameDeviceModel}, canActivate: [RoleGuard]},

  {path: 'edit-organization-unit-anagraf', component: EditOrganizationUnitAnagrafComponent, data: {row: OrganizationUnitModel}, canActivate: [RoleGuard]},

  {path: 'edit-local-customer-settings', component: EditLocalCustomerComponent, data : {row : LocalCustomerSettingsModel}, canActivate: [RoleGuard]},

  {path: 'edit-contract-type-settings', component: EditContractComponent, data : {row : ContractSettingsModel}, canActivate: [RoleGuard]},

  {path: 'edit-architecture-structure', component: EditArchitectureStructureComponent, data : {row : ArchitectureStructureSettingModel}, canActivate: [RoleGuard]},

  {path: 'edit-currency-setting', component: EditCurrencySettingComponent, data : {row : CurrencySettingModel}, canActivate: [RoleGuard]},

  {path: 'edit-contractual-values', component: EditContractualValuesComponent, data : {row : ContractualDataModel}, canActivate: [RoleGuard]},

  {path: 'edit-contractual-values-massive', component: EditContractualValuesMassiveComponent, data : {row : ContractualDataModel}, canActivate: [RoleGuard]},

  {path: 'edit-discount', component: EditDiscountComponent, canActivate: [RoleGuard]},

  {path: 'edit-discount-massive', component: EditDiscountMassiveComponent, canActivate: [RoleGuard]},

  {path: 'edit-minimum-comm', component: EditMinimumCommComponent, data : {row : MinimumCommModel}, canActivate: [RoleGuard]},

  {path: 'edit-rate-card', component: EditRateCardComponent, canActivate: [RoleGuard]},

  {path: 'edit-reimbursment', component: EditReimbursmentComponent, canActivate: [RoleGuard]},

  {path: 'edit-termination-fee', component: EditTerminationFeeComponent, canActivate: [RoleGuard]},

  {path: 'edit-service-changes', component: EditServiceChangesComponent, data : {row : ServiceChangesModel}, canActivate: [RoleGuard]},

  {path: 'edit-service-changes-massive', component: EditServiceChangesMassiveComponent, data : {row : ServiceChangesModel}, canActivate: [RoleGuard]},

  {path: 'edit-service-variant-anagraf', component: EditServiceVariantAnagrafComponent, data : {row : ServiceVariantModel}, canActivate: [RoleGuard]},

  {path: 'edit-transformation', component: EditTransformationComponent, data : {row : TransformationModel}, canActivate: [RoleGuard]},

  {path: 'new-users', component: NewUsersComponent, canActivate: [RoleGuard]},

  {path: 'edit-users', component: EditUsersComponent, data : {row : UserModel}, canActivate: [RoleGuard]}

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [RoleGuard, AuthService, authGuard, EmployeeService, UserService]
})

export class AppRoutingModule {
}

